import { checkTuXung } from '../core/interactions.js';

const STEM_CLASH = [
  ['Giap', 'Ky'],
  ['At', 'Canh'],
  ['Binh', 'Tan'],
  ['Dinh', 'Nham'],
  ['Mau', 'Quy']
];

const checkStemClash = (a, b) => (
  STEM_CLASH.some((pair) => pair.includes(a) && pair.includes(b))
);

export function annualFortune(yearCan, yearChi, pillars) {
  const conflicts = pillars.filter((p) => checkTuXung(yearChi, p.chi));
  const stemConflicts = pillars.filter((p) => checkStemClash(yearCan, p.can));

  const hasConflict = conflicts.length > 0 || stemConflicts.length > 0;

  return {
    xung: hasConflict,
    note: hasConflict ? 'Nam co xung/khac, can than trong quyet dinh' : 'Nam on dinh',
    chi_conflicts: conflicts.map((p) => p.label),
    stem_conflicts: stemConflicts.map((p) => p.label)
  };
}
